import Vue from 'vue'
import VueRouter from 'vue-router'
import Homepage from '@/components/Homepage'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Homepage',
      component: Homepage
    },
    {
      path: '/register',
      name: 'register',
      component: resolve => (require(["@/components/register"], resolve))
    },
    {
      path: '/registertwo',
      name: 'registertwo',
      component: resolve => (require(["@/components/registertwo"], resolve))
    },
    {
      path: '/registerthree',
      name: 'registerthree',
      component: resolve => (require(["@/components/registerthree"], resolve))
    },
    {
      path: '/experiment',
      name: 'experiment',
      component: resolve => (require(["@/components/experiment"], resolve))
    },
    {
      path: '/admin',
      name: 'admin',
      component: resolve => (require(["@/components/admin"], resolve))
    },
    {
      path: '/Details',
      name: 'Details',
      component: resolve => (require(["@/components/Details"], resolve))
    },
    {
      path: '/adminone',
      name: 'adminone',
      component: resolve => (require(["@/components/adminone"], resolve))
    }, {
      path: '/admintwo',
      name: 'admintwo',
      component: resolve => (require(["@/components/admintwo"], resolve))
    },
    {
      path: '/adminthree',
      name: 'adminthree',
      component: resolve => (require(["@/components/adminthree"], resolve))
    },
    {
      path: '/phonelogin',
      name: 'phonelogin',
      component: resolve => (require(["@/components/phonelogin"], resolve))
    },
    {
      path: '/phonezhuce',
      name: 'phonezhuce',
      component: resolve => (require(["@/components/phonezhuce"], resolve))
    },
    {
      path: '/news',
      name: 'news',
      component: resolve => (require(["@/components/news"], resolve))
    }, {
      path: '/Newslist',
      name: 'Newslist',
      component: resolve => (require(["@/components/Newslist"], resolve))
    }
  ]


})

// // 登陆守卫
// VueRouter.beforeEach((to, from, next) => {
//   // to and from are both route objects. must call `next`.
//  if(to.path==='admin'){
//   if(localStorage.getItem('UserAccount')){
//     next()
//   }else{
//     next('/')
//   }
//  }
// })



// WEBPACK FOOTER //
// ./src/router/index.js